var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import { Translate } from "../I18N";









export const DocumentCounter = (props) => {
  const {
    totalConnectionsCount,
    selectedEntitiesCount,
    entityListCount,
    entityTotal,
    hitsTotalRelation
  } = props;
  const totalEntitiesValue = /*#__PURE__*/_jsx("b", {}, void 0, " ", `${entityTotal}${hitsTotalRelation === 'gte' ? '+' : ''}`, " ");
  const entityCounter = /*#__PURE__*/
  React.createElement(React.Fragment, null,
  selectedEntitiesCount > 0 && /*#__PURE__*/
  React.createElement(React.Fragment, null, /*#__PURE__*/
  _jsx("b", {}, void 0, " ", selectedEntitiesCount, " "), " ", /*#__PURE__*/_jsx(Translate, {}, void 0, "selected of")
  ), /*#__PURE__*/

  _jsx("b", {}, void 0, " ", entityListCount, " "), " ", /*#__PURE__*/_jsx(Translate, {}, void 0, "shown of"),
  totalEntitiesValue, /*#__PURE__*/
  _jsx(Translate, {}, void 0, "entities")
  );

  const connectionsCounter = /*#__PURE__*/
  React.createElement(React.Fragment, null, /*#__PURE__*/
  _jsx("b", {}, void 0, totalConnectionsCount, " "), /*#__PURE__*/
  _jsx(Translate, {}, void 0, "relationships"), ", ", /*#__PURE__*/_jsx("b", {}, void 0, totalEntitiesValue, " "), /*#__PURE__*/
  _jsx(Translate, {}, void 0, "entities")
  );


  return /*#__PURE__*/_jsx("span", {}, void 0, totalConnectionsCount === undefined ? entityCounter : connectionsCounter);
};